import axios, { AxiosResponse } from "axios";

const request = axios.create({
    baseURL: 'http://103.5.193.60:3000/api/',
});
// 响应拦截器
const responseHandler = (
    response: AxiosResponse,
): any | AxiosResponse<any> | Promise<any> | any => {
    return response.data;
};

// Add a response interceptor
request.interceptors.response.use(responseHandler);

export async function getReportList(): Promise<any> {
    return request.post<any, any>('report/list');
}

export async function connectUs(params: any): Promise<any> {
    return request.post<any, any>('contact/create', params);
}

export async function getEmploymentList(): Promise<any> {
    return request.post<any, any>('employment/list');
}

export async function downloadReport(params: any): Promise<any> {
    return request.post<any, any>('report/download', params);
}

export async function view(params: any={}): Promise<any> {
    return request.post<any, any>('system/view', params);
}
